"use client"

import { useContext, useRef } from "react"
import type { HTMLAttributes } from "react"

import { ImpressionsTrackingScope } from "@/platform/observability/impressions/tracking-scope"
import { useImpression, useImpressions } from "@/platform/observability/impressions/use-impression"
import { recordServeClick } from "@/platform/observability/impressions/visibility"

interface ImpressionTargetProps extends HTMLAttributes<HTMLDivElement> {
  serveId?: string
}

export const ImpressionTarget = ({ serveId, children, ...rest }: ImpressionTargetProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const tracked = useContext(ImpressionsTrackingScope)
  const trackedServeId = tracked ? serveId : undefined
  useImpression(ref, trackedServeId)
  return (
    <div ref={ref} data-nelo-serve={serveId} onClickCapture={trackedServeId ? (event) => recordServeClick(event.nativeEvent) : undefined} {...rest}>
      {children}
    </div>
  )
}

interface ImpressionListProps extends HTMLAttributes<HTMLDivElement> {
  serveIds?: readonly (string | null | undefined)[]
  region?: boolean
}

export const ImpressionList = ({ serveIds, region = false, children, ...rest }: ImpressionListProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const tracked = useContext(ImpressionsTrackingScope)
  const present = (serveIds ?? []).filter((serveId): serveId is string => Boolean(serveId))
  useImpressions(ref, tracked ? present : [], { container: true, region })
  return (
    <div ref={ref} data-nelo-serve={present[0]} onClickCapture={tracked && present.length > 0 ? (event) => recordServeClick(event.nativeEvent) : undefined} {...rest}>
      {children}
    </div>
  )
}
